export const AISLE_LAUNCH_SET_STEP = 'AISLE_LAUNCH_SET_STEP';
export const AISLE_PUSH_CONFIG = 'AISLE_PUSH_CONFIG';
export const AISLE_REPLACE_CONFIG = 'AISLE_REPLACE_CONFIG';
export const AISLE_STREAM_NAME = 'AISLE_STREAM_NAME';
export const AISLE_STREAM_ADD_ACTIONS = 'AISLE_STREAM_ADD_ACTIONS';
export const AISLE_STREAM_CAMPAIGN = 'AISLE_STREAM_CAMPAIGN';

export const aisleSetActiveStep = (step) => ({
  type: AISLE_LAUNCH_SET_STEP,
  payload: step,
});

export const aislePushConfigByName = (name, payload) => ({
  type: AISLE_PUSH_CONFIG,
  name,
  payload,
});

export const aisleReplaceConfigByName = (name, payload) => ({
  type: AISLE_REPLACE_CONFIG,
  name,
  payload,
});

export const aisleStreamNameUpdate = (payload) => ({
  type: AISLE_STREAM_NAME,
  payload,
});

export const aisleStreamAddRules = (payload) => ({
  type: AISLE_STREAM_ADD_ACTIONS,
  payload,
});
